export default __webpack_public_path__ + "static/media/icon-success.e0144ca6.svg";